import React, { useContext } from 'react'
import { ApiGetCall } from '../../JS/Connector';
import AlertsComp from '../../Components/AlertsComp';
import { formatDateToMMDDYYYY, MMDDYYYY } from '../../JS/Common';
import GreyBoxForReports from './GreyBoxForReports';
import { log } from '../../JS/Logger';
import useConfig from '../../Hooks/useConfig';

export default function MassIncomingBatch({ setLoading, FilterData, setalerts, downloadAllChecked }) {
    const { organization } = useConfig();
    async function GetBatchData() {
        var downloadall = 0;
        if (downloadAllChecked) {
            downloadall = 1;
        }
        setLoading(true);
        await ApiGetCall(`/reports/incoming-batch-details?startDate=${formatDateToMMDDYYYY(FilterData.StartDate)}&endDate=${formatDateToMMDDYYYY(FilterData.EndDate)}&locationId=${FilterData.Location}&schoolId=${FilterData.School}&flag=${downloadall}`).then((result) => {
            if (result == undefined || result == "") {
                alert("Something went wrong");
            } else {
                const responseRs = JSON.parse(result);
                if (responseRs.length > 0) {
                    DownloadCsv(responseRs);
                } else {
                    DownloadCsv([]);
                    setalerts(<AlertsComp show={true} variant="danger" msg={"No Data Found"} />);
                    setTimeout(() => {
                        setalerts(<AlertsComp show={false} />);
                    }, 2000);
                }
                setLoading(false);
            }
        });
    }
    const DownloadCsv = (CsvData) => {
        const csvContent = [];
        const PurchaseMap = [];
        CsvData?.forEach((item) => {
            const rowData = {
                [`${organization} Name`]: item.school_name,
                'Batch Name': item.batch_name,
                'Create Date': item.created_at ? formatDateToMMDDYYYY(item.created_at) : '-',
                'Receive Date': item.received_date ? formatDateToMMDDYYYY(item.received_date) : '-',
                'Received By': item.batch_received_by,
                'Device Count': item.device_count,
                [`${organization} Type`]: item.school_type == 1 ? 'Local' : 'Mail In'
            };
            PurchaseMap.push(rowData);
        });

        if (PurchaseMap.length > 0) {
            const headers = [`${organization} Name`, 'Batch Name', 'Create Date', 'Receive Date', 'Received By', 'Device Count', `${organization} Type`];
            csvContent.push(headers);
            PurchaseMap.forEach((rowData) => {
                const values = Object.values(rowData).map(value => {
                    if (typeof value == 'string' && value.includes(',')) {
                        return `"${value}"`;
                    }
                    return value;
                });
                csvContent.push(values);
            });
            csvContent.push([]);
            const csvString = csvContent.map((row) => row.join(',')).join('\n');
            const blob = new Blob([csvString], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = 'BulkIncomingBatches.csv';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            log.error('No data available for download.');
        }
    };
    return (
        <GreyBoxForReports icon="faTruckFast" name={"Bulk Incoming Batches Report Download"} onclickfunc={GetBatchData} />
    )
}
